export default __webpack_public_path__ + "static/media/8.67643c0a.png";